<div class="d-block w-100">
  <ul class="list-unstyled" id="searchFields">
    <li>
      <div class="tab w-100">
        <a #dateCreated
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == dateCreated.id}"
          id="dateCreatedFilter">
          Date&nbsp;Created <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #accountStatus
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == accountStatus.id}"
          id="accountStatusFilter">
          Status <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #description
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == description.id}"
          id="descriptionFilter">
          Description <em class="dropdown-toggle" style="float: right"></em>
        </a>
      </div>
      <form [formGroup]="form">
        <div>
          @switch (activeTab) {
            @case (dateCreated.id) {
              <div class="tabcontent">
                <div class="date-input-group">
                  <label class="date-label" for="dateTimeCreatedLower">From:</label>
                  <input (change)="setSearchCriteria($event)"
                    class="form-control d-inline"
                    formControlName="dateTimeCreatedLower"
                    id="dateTimeCreatedLower"
                    max="{{dateCreatedUpper}}"
                    placeholder=""
                    type="date"
                    value="{{dateCreatedLower}}"/>
                </div>
                <div class="date-input-group">
                  <label class="date-label" for="dateTimeCreatedUpper">To:</label>
                  <input (change)="setSearchCriteria($event)"
                    class="form-control d-inline"
                    formControlName="dateTimeCreatedUpper"
                    id="dateTimeCreatedUpper"
                    min="{{dateCreatedLower}}"
                    placeholder=""
                    type="date"
                    value="{{dateCreatedUpper}}"/>
                </div>
              </div>
            }
            @case (accountStatus.id) {
              <div class="tabcontent">
                <p-select (onChange)="setSearchCriteriaStatus($event.value)"
                  [options]="statusOptions"
                  class="form-control"
                  formControlName="displayStatus"
                  id="status"
                  optionLabel="label"
                optionValue="value"></p-select>
              </div>
            }
            @case (description.id) {
              <div class="tabcontent">
                <input (input)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="description"
                  id="description"
                  placeholder="Description"
                  type="text"/>
              </div>
            }
          }
        </div>
        <div class="row">
          <div [hidden]="!tabActive" class="col-md-12 text-center">
            <button (click)="clear(activeTab)"
              [disabled]="disableClear(activeTab)"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="button">
              Clear
            </button>
            <button (click)="clearAll()"
              [disabled]="disableClearAll()"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="button">
              Clear All
            </button>
            <button (click)="search()"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="submit">
              Update
            </button>
          </div>
        </div>
      </form>
    </li>
  </ul>
</div>